/* eslint-disable max-len */
import React from 'react';

export const Check = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      d="M12.3545 6.18538C12.5498 5.99012 12.5498 5.67354 12.3545 5.47827L11.4502 4.574C11.255 4.37874 10.9384 4.37874 10.7431 4.574L6.8463 8.47083C6.65104 8.66609 6.33446 8.66609 6.1392 8.47083L4.54434 6.87597C4.34908 6.68071 4.03249 6.68071 3.83723 6.87597L2.93296 7.78024C2.7377 7.9755 2.7377 8.29209 2.93296 8.48735L6.1392 11.6936C6.33446 11.8888 6.65104 11.8888 6.8463 11.6936L12.3545 6.18538Z"
      fill="#303036"
    />
  </svg>
);
export const LockClose = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 10H5C3.34315 10 2 11.3431 2 13V20C2 21.6569 3.34315 23 5 23H19C20.6569 23 22 21.6569 22 20V13C22 11.3431 20.6569 10 19 10H18V7C18 3.68629 15.3137 1 12 1C8.68629 1 6 3.68629 6 7V10ZM8 10H16V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V10ZM17 12H19C19.5523 12 20 12.4477 20 13V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V13C4 12.4477 4.44772 12 5 12H7H17Z"
      fill="black"
    />
    <mask
      id="mask0_22085:149627"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="1"
      width="20"
      height="22"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10H5C3.34315 10 2 11.3431 2 13V20C2 21.6569 3.34315 23 5 23H19C20.6569 23 22 21.6569 22 20V13C22 11.3431 20.6569 10 19 10H18V7C18 3.68629 15.3137 1 12 1C8.68629 1 6 3.68629 6 7V10ZM8 10H16V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V10ZM17 12H19C19.5523 12 20 12.4477 20 13V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V13C4 12.4477 4.44772 12 5 12H7H17Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_22085:149627)">
      <rect className="fill" width="24" height="24" fill="black" />
    </g>
  </svg>
);
export const LockOpen = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.125 6.87494H3.75L3.75 5.00056C3.74806 3.07399 5.20631 1.4594 7.12313 1.26578C9.03995 1.07216 10.7916 2.36252 11.175 4.25057C11.2437 4.58884 11.0251 4.91875 10.6869 4.98744C10.3486 5.05613 10.0187 4.83758 9.95 4.49931C9.69441 3.24061 8.52663 2.38037 7.24875 2.50945C5.97087 2.63853 4.99871 3.71493 5 4.99994V6.87494H11.875C12.9105 6.87494 13.75 7.7144 13.75 8.74994V13.1249C13.75 14.1605 12.9105 14.9999 11.875 14.9999H3.125C2.08947 14.9999 1.25 14.1605 1.25 13.1249V8.74994C1.25 7.7144 2.08947 6.87494 3.125 6.87494ZM2.5 8.74994C2.5 8.40476 2.77982 8.12494 3.125 8.12494H11.875C12.2202 8.12494 12.5 8.40476 12.5 8.74994V13.1249C12.5 13.4701 12.2202 13.7499 11.875 13.7499H3.125C2.77982 13.7499 2.5 13.4701 2.5 13.1249V8.74994Z"
      fill="black"
    />
    <mask
      id="mask0_22021:4654"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="13"
      height="14"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.125 6.87494H3.75L3.75 5.00056C3.74806 3.07399 5.20631 1.4594 7.12313 1.26578C9.03995 1.07216 10.7916 2.36252 11.175 4.25057C11.2437 4.58884 11.0251 4.91875 10.6869 4.98744C10.3486 5.05613 10.0187 4.83758 9.95 4.49931C9.69441 3.24061 8.52663 2.38037 7.24875 2.50945C5.97087 2.63853 4.99871 3.71493 5 4.99994V6.87494H11.875C12.9105 6.87494 13.75 7.7144 13.75 8.74994V13.1249C13.75 14.1605 12.9105 14.9999 11.875 14.9999H3.125C2.08947 14.9999 1.25 14.1605 1.25 13.1249V8.74994C1.25 7.7144 2.08947 6.87494 3.125 6.87494ZM2.5 8.74994C2.5 8.40476 2.77982 8.12494 3.125 8.12494H11.875C12.2202 8.12494 12.5 8.40476 12.5 8.74994V13.1249C12.5 13.4701 12.2202 13.7499 11.875 13.7499H3.125C2.77982 13.7499 2.5 13.4701 2.5 13.1249V8.74994Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_22021:4654)">
      <rect className="fill" width="15" height="15" fill="black" />
    </g>
  </svg>
);
export const Key = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 5.99999L12 8.99999L9.7 6.69999L7 9.39999C8.4 11 8.3 13.3 6.9 14.9C5.3 16.5 2.8 16.5 1.2 14.9C-0.4 13.3 -0.4 10.8 1.2 9.19999C2.3 7.99999 3.9 7.69999 5.3 8.29999L13.3 0.299988L14.7 1.69999L12.7 3.69999L15 5.99999ZM4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14Z"
      fill="#303036"
    />
  </svg>
);
export const EyeOn = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      d="M8.00002 14C11.6 14 14.4 10.9 15.6 9.1C16.1 8.4 16.1 7.5 15.6 6.8C14.4 5.1 11.6 2 8.00002 2C4.40002 2 1.60002 5.1 0.400024 6.9C-0.0999756 7.6 -0.0999756 8.5 0.400024 9.1C1.60002 10.9 4.40002 14 8.00002 14ZM8.00002 5C9.70002 5 11 6.3 11 8C11 9.7 9.70002 11 8.00002 11C6.30002 11 5.00002 9.7 5.00002 8C5.00002 6.3 6.30002 5 8.00002 5Z"
      fill="#303036"
    />
  </svg>
);
export const EyeOff = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6 3L14.3 0.3C14.7 -0.1 15.3 -0.1 15.7 0.3C16.1 0.7 16.1 1.3 15.7 1.7L1.7 15.7C1.5 15.9 1.3 16 1 16C0.7 16 0.5 15.9 0.3 15.7C-0.1 15.3 -0.1 14.7 0.3 14.3L2.8 11.8C1.8 10.9 0.9 9.9 0.4 9.1C-0.1 8.5 -0.1 7.6 0.4 6.9C1.6 5.1 4.4 2 8 2C9.3 2 10.5 2.4 11.6 3ZM5 8C5 8.5 5.1 8.9 5.3 9.3L9.3 5.3C8.9 5.1 8.5 5 8 5C6.3 5 5 6.3 5 8ZM6.40002 13.8L14.6 5.60001C14.7754 5.81923 14.9508 6.01923 15.1093 6.20001C15.3123 6.43154 15.4877 6.63154 15.6 6.80001C16.1 7.50001 16.1 8.40001 15.6 9.10001C14.4 10.9 11.6 14 8.00002 14C7.50002 14 6.90002 13.9 6.40002 13.8Z"
      fill="#303036"
    />
  </svg>
);
export const Play = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      d="M14.5 7.13398C15.1667 7.51888 15.1667 8.48113 14.5 8.86603L5.5 14.0622C4.83333 14.4471 4 13.966 4 13.1962V2.80385C4 2.03405 4.83333 1.55292 5.5 1.93782L14.5 7.13398Z"
      fill="#303036"
    />
  </svg>
);
export const Grid = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 1H10C9.4 1 9 1.4 9 2V6C9 6.6 9.4 7 10 7H14C14.6 7 15 6.6 15 6V2C15 1.4 14.6 1 14 1ZM14 9H10C9.4 9 9 9.4 9 10V14C9 14.6 9.4 15 10 15H14C14.6 15 15 14.6 15 14V10C15 9.4 14.6 9 14 9ZM2 9H6C6.6 9 7 9.4 7 10V14C7 14.6 6.6 15 6 15H2C1.4 15 1 14.6 1 14V10C1 9.4 1.4 9 2 9Z"
      fill="#303036"
    />
    <path
      className="fill"
      d="M6 1H2C1.4 1 1 1.4 1 2V6C1 6.6 1.4 7 2 7H6C6.6 7 7 6.6 7 6V2C7 1.4 6.6 1 6 1Z"
      fill="#303036"
    />
  </svg>
);
export const Settings = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.70625 14.5768L2.82187 15.0877L2.82281 15.0887C3.28874 15.3015 3.51187 15.8387 3.33374 16.3196L2.89687 17.469C2.56313 18.3334 2.68687 19.3075 3.22593 20.0612C3.75 20.8291 4.62093 21.2875 5.55093 21.2856C5.89593 21.2866 6.23813 21.2228 6.55874 21.0981L7.70813 20.6613H7.70906C7.81781 20.6172 7.935 20.5966 8.05219 20.6013C8.4347 20.5984 8.78251 20.8225 8.93719 21.1722L9.44813 22.2878L9.44906 22.2887C9.90751 23.2984 10.9144 23.9462 12.0226 23.9462C13.1316 23.9462 14.1385 23.2984 14.5971 22.2887L15.1202 21.1656C15.2777 20.8178 15.6236 20.5938 16.0061 20.5938C16.1233 20.5909 16.2396 20.6116 16.3493 20.6537L17.4986 21.1047V21.1056C17.8202 21.2322 18.1614 21.3006 18.5065 21.3072C19.4365 21.2894 20.3018 20.8272 20.8324 20.0641C21.3621 19.3009 21.4849 18.3278 21.1615 17.4569L20.7124 16.3076C20.5399 15.8285 20.7611 15.2979 21.2233 15.0841L22.3389 14.5732V14.5722C23.3486 14.1138 23.9974 13.1069 23.9974 11.9987C23.9974 10.8896 23.3486 9.88277 22.3389 9.42423L21.2233 8.91329C20.7555 8.69954 20.5324 8.16142 20.7124 7.67955L21.1493 6.53017C21.483 5.66578 21.3593 4.69172 20.8202 3.93792C20.2952 3.17012 19.4243 2.71167 18.4943 2.71354C18.1502 2.7126 17.808 2.77635 17.4865 2.90104L16.3371 3.33791C16.2283 3.38197 16.1111 3.4026 15.9939 3.39791C15.6171 3.39791 15.2758 3.17666 15.1202 2.83353L14.5971 1.71791C14.1433 0.704465 13.1346 0.0529127 12.0245 0.0566567C10.8967 0.0557192 9.87295 0.712913 9.40322 1.73666L8.8801 2.84853C8.7226 3.19634 8.37665 3.41947 7.99416 3.41947C7.88166 3.42134 7.76916 3.40072 7.66322 3.35947L6.51384 2.92259C5.29603 2.45572 3.918 2.88415 3.18 3.95947C2.65126 4.71695 2.52845 5.68634 2.85094 6.55171L3.28781 7.70109C3.46031 8.18015 3.23906 8.71171 2.77687 8.92547L1.66126 9.43641C0.65064 9.88828 0 10.8923 0 11.9996C0.00937488 13.1209 0.678744 14.1305 1.70626 14.5767L1.70625 14.5768ZM2.46751 11.1155L3.58312 10.6046V10.6055C4.93593 9.98773 5.58 8.42866 5.05687 7.03649L4.62 5.88711C4.50374 5.59273 4.54406 5.25898 4.72781 5.00117C4.97719 4.62243 5.45906 4.4743 5.87719 4.64585L7.02658 5.08273H7.02751C7.34439 5.2046 7.68096 5.26835 8.02126 5.27023C9.13032 5.26273 10.1353 4.61023 10.5938 3.59961L11.1048 2.48399C11.2632 2.13338 11.6157 1.91119 12.0001 1.91961C12.3826 1.9168 12.7304 2.14086 12.886 2.49055L13.3876 3.59961C13.8432 4.61493 14.8491 5.27116 15.9628 5.27961C16.3021 5.28055 16.6396 5.2168 16.9556 5.09211L18.105 4.65524H18.1059C18.525 4.50336 18.9946 4.64774 19.2553 5.01056C19.439 5.26837 19.4803 5.60211 19.3631 5.89649L18.9262 7.04588C18.4181 8.43526 19.0584 9.98204 20.4 10.6056L21.5156 11.1165C21.8624 11.2731 22.0837 11.6199 22.08 11.9996C22.0828 12.3821 21.8587 12.7299 21.509 12.8856L20.4 13.3984C19.0472 14.0162 18.404 15.5752 18.9262 16.9674L19.3631 18.1168C19.4793 18.4112 19.439 18.7449 19.2553 19.0027C19.0068 19.3815 18.524 19.5305 18.1059 19.358L16.9565 18.9212H16.9556C16.6387 18.7993 16.3021 18.7356 15.9628 18.7337C14.8528 18.7393 13.8478 19.3899 13.3876 20.3996L12.8766 21.5152H12.8757C12.7201 21.8593 12.3779 22.0805 12.0001 22.0796C11.6176 22.0824 11.2698 21.8584 11.1141 21.5087L10.5938 20.3996C10.1316 19.3918 9.12662 18.744 8.01862 18.7384C7.6783 18.7384 7.34174 18.8021 7.02487 18.9259L5.87549 19.3627C5.45549 19.5155 4.98581 19.3702 4.7261 19.0074C4.54142 18.7496 4.5011 18.4168 4.61736 18.1224L5.05423 16.973V16.9721C5.56891 15.5808 4.92767 14.0273 3.58142 13.404L2.46768 12.8875C2.11612 12.7328 1.89019 12.384 1.89393 11.9996C1.89206 11.6171 2.11706 11.2703 2.46768 11.1165L2.46751 11.1155Z"
      fill="white"
    />
    <path
      d="M11.9813 16.0341C13.051 16.0341 14.0766 15.6085 14.8323 14.8509C15.5888 14.0944 16.0135 13.0678 16.0126 11.9981C16.0126 10.9284 15.587 9.90274 14.8304 9.14614C14.0738 8.38959 13.0473 7.96489 11.9775 7.96582C10.9078 7.96582 9.88219 8.3905 9.12559 9.14708C8.36904 9.90363 7.94434 10.9302 7.94434 12C7.94809 13.0696 8.37466 14.0934 9.13027 14.849C9.88682 15.6056 10.9115 16.0312 11.9812 16.034L11.9813 16.0341ZM11.9813 9.82959V9.83053C12.8541 9.83053 13.6426 10.3565 13.9763 11.1637C14.311 11.9708 14.1263 12.8999 13.5085 13.5177C12.8907 14.1355 11.9616 14.3202 11.1544 13.9855C10.3472 13.6518 9.8213 12.8643 9.8213 11.9905C9.8363 10.8055 10.7963 9.85021 11.9813 9.83991V9.82959Z"
      fill="white"
    />
  </svg>
);
export const Options = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 3.25C4.80964 3.25 4.25 3.80964 4.25 4.5C4.25 5.19036 4.80964 5.75 5.5 5.75C6.19036 5.75 6.75 5.19036 6.75 4.5C6.75 3.80964 6.19036 3.25 5.5 3.25ZM5.5 7.25C4.24122 7.25 3.17998 6.40425 2.85352 5.25H1.5C1.08579 5.25 0.75 4.91421 0.75 4.5C0.75 4.08579 1.08579 3.75 1.5 3.75H2.85352C3.17998 2.59575 4.24122 1.75 5.5 1.75C7.01878 1.75 8.25 2.98122 8.25 4.5C8.25 6.01878 7.01878 7.25 5.5 7.25ZM10.5 3.75C10.0858 3.75 9.75 4.08579 9.75 4.5C9.75 4.91421 10.0858 5.25 10.5 5.25H14.5C14.9142 5.25 15.25 4.91421 15.25 4.5C15.25 4.08579 14.9142 3.75 14.5 3.75H10.5ZM0.75 12.5C0.75 12.0858 1.08579 11.75 1.5 11.75H5.5C5.91421 11.75 6.25 12.0858 6.25 12.5C6.25 12.9142 5.91421 13.25 5.5 13.25H1.5C1.08579 13.25 0.75 12.9142 0.75 12.5ZM11.75 12.5C11.75 11.8096 11.1904 11.25 10.5 11.25C9.80964 11.25 9.25 11.8096 9.25 12.5C9.25 13.1904 9.80964 13.75 10.5 13.75C11.1904 13.75 11.75 13.1904 11.75 12.5ZM14.5 11.75H13.1465C12.82 10.5957 11.7588 9.75 10.5 9.75C8.98122 9.75 7.75 10.9812 7.75 12.5C7.75 14.0188 8.98122 15.25 10.5 15.25C11.7588 15.25 12.82 14.4043 13.1465 13.25H14.5C14.9142 13.25 15.25 12.9142 15.25 12.5C15.25 12.0858 14.9142 11.75 14.5 11.75Z"
      fill="#303036"
    />
  </svg>
);
export const Submit = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4167 3.33331C13.4167 2.9191 13.0809 2.58331 12.6667 2.58331C12.2525 2.58331 11.9167 2.9191 11.9167 3.33331V7.41665C11.9167 7.83657 11.7499 8.2393 11.453 8.53623C11.156 8.83316 10.7533 8.99998 10.3334 8.99998H5.14403L6.78037 7.36364C7.07326 7.07075 7.07326 6.59588 6.78037 6.30298C6.48748 6.01009 6.0126 6.01009 5.71971 6.30298L2.80304 9.21965C2.73114 9.29156 2.67688 9.37443 2.64028 9.46289C2.60361 9.55132 2.58337 9.64829 2.58337 9.74998C2.58337 9.85167 2.60361 9.94864 2.64028 10.0371C2.67688 10.1255 2.73114 10.2084 2.80304 10.2803L5.71971 13.197C6.0126 13.4899 6.48748 13.4899 6.78037 13.197C7.07326 12.9041 7.07326 12.4292 6.78037 12.1363L5.14403 10.5H10.3334C11.1511 10.5 11.9354 10.1751 12.5136 9.59689C13.0919 9.01866 13.4167 8.2344 13.4167 7.41665V3.33331Z"
      fill="#303036"
    />
  </svg>
);
export const LinkIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      d="M5.35012 10.7C5.73672 11.0866 6.36352 11.0866 6.75012 10.7C7.13672 10.3134 7.13672 9.6866 6.75012 9.3C5.75012 8.3 5.75012 6.7 6.75012 5.7L9.75012 2.7C10.7501 1.7 12.3501 1.7 13.3501 2.7C14.3501 3.7 14.3501 5.3 13.3501 6.3C12.9635 6.6866 12.9635 7.3134 13.3501 7.7C13.7367 8.0866 14.3635 8.0866 14.7501 7.7C16.5501 5.9 16.5501 3.1 14.7501 1.3C13.8501 0.5 12.7501 0 11.5501 0C10.3501 0 9.25012 0.4 8.35012 1.3L5.35012 4.3C3.55012 6.1 3.55012 8.9 5.35012 10.7Z"
      fill="#303036"
    />
    <path
      className="fill"
      d="M1.35012 14.7001C2.25012 15.5001 3.35012 16.0001 4.55012 16.0001C5.75012 16.0001 6.95012 15.5001 7.75012 14.7001L10.7501 11.7001C12.5501 9.9001 12.5501 7.1001 10.7501 5.3001C10.3635 4.9135 9.73672 4.9135 9.35012 5.3001C8.96352 5.6867 8.96352 6.3135 9.35012 6.7001C10.3501 7.7001 10.3501 9.3001 9.35012 10.3001L6.35012 13.3001C5.35012 14.3001 3.75012 14.3001 2.75012 13.3001C1.75012 12.3001 1.75012 10.7001 2.75012 9.7001C3.13672 9.3135 3.13672 8.6867 2.75012 8.3001C2.36352 7.9135 1.73672 7.9135 1.35012 8.3001C-0.449878 10.1001 -0.449878 12.9001 1.35012 14.7001Z"
      fill="#303036"
    />
  </svg>
);
export const Styles = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      d="M6.94969 0.565186L2.70709 4.80779L11.1923 13.293L15.4349 9.05038L6.94969 0.565186Z"
      fill="#303036"
    />
    <path
      className="fill"
      opacity="0.3"
      d="M1.29299 6.22198L0.585994 6.92898C-0.195006 7.70998 -0.195006 8.97598 0.585994 9.75698L1.99999 11.172L0.585994 12.586C-0.195006 13.367 -0.195006 14.633 0.585994 15.414C1.36699 16.195 2.63299 16.195 3.41399 15.414L4.82799 14L6.24199 15.414C7.02299 16.195 8.28899 16.195 9.06999 15.414L9.77699 14.707L1.29299 6.22198Z"
      fill="#303036"
    />
  </svg>
);
export const Drag = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 12C5 12.5523 5.44772 13 6 13C6.55228 13 7 12.5523 7 12C7 11.4477 6.55228 11 6 11C5.44772 11 5 11.4477 5 12ZM5 8C5 8.55228 5.44772 9 6 9C6.55228 9 7 8.55228 7 8C7 7.44772 6.55228 7 6 7C5.44772 7 5 7.44772 5 8ZM6 5C5.44772 5 5 4.55229 5 4C5 3.44771 5.44772 3 6 3C6.55228 3 7 3.44771 7 4C7 4.55229 6.55228 5 6 5ZM9 12C9 12.5523 9.44772 13 10 13C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11C9.44772 11 9 11.4477 9 12ZM9 8C9 8.55228 9.44772 9 10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8ZM10 5C9.44772 5 9 4.55229 9 4C9 3.44771 9.44772 3 10 3C10.5523 3 11 3.44771 11 4C11 4.55229 10.5523 5 10 5Z"
      fill="#303036"
    />
  </svg>
);
export const Faq = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 13C7.4 13 7 12.6 7 12C7 11.4 7.4 11 8 11C8.6 11 9 11.4 9 12C9 12.6 8.6 13 8 13ZM9.5 8.4C9 8.7 9 8.8 9 9V10H7V9C7 7.7 7.8 7.1 8.4 6.7C8.9 6.4 9 6.3 9 6C9 5.4 8.6 5 8 5C7.6 5 7.3 5.2 7.1 5.5L6.6 6.4L4.9 5.4L5.4 4.5C5.9 3.6 6.9 3 8 3C9.7 3 11 4.3 11 6C11 7.4 10.1 8 9.5 8.4Z"
      fill="#303036"
    />
  </svg>
);
export const Search = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 7.28572C3.75 5.33299 5.33299 3.75 7.28572 3.75C9.23844 3.75 10.8214 5.33299 10.8214 7.28572C10.8214 8.25169 10.4341 9.12718 9.80619 9.76533C9.79915 9.77185 9.79221 9.77853 9.78537 9.78537C9.77853 9.79221 9.77185 9.79915 9.76533 9.80619C9.12718 10.4341 8.25169 10.8214 7.28572 10.8214C5.33299 10.8214 3.75 9.23844 3.75 7.28572ZM10.2767 11.3374C9.44034 11.9558 8.40573 12.3214 7.28572 12.3214C4.50457 12.3214 2.25 10.0669 2.25 7.28572C2.25 4.50457 4.50457 2.25 7.28572 2.25C10.0669 2.25 12.3214 4.50457 12.3214 7.28572C12.3214 8.40573 11.9558 9.44034 11.3374 10.2767L13.5303 12.4697C13.8232 12.7626 13.8232 13.2374 13.5303 13.5303C13.2374 13.8232 12.7626 13.8232 12.4697 13.5303L10.2767 11.3374Z"
      fill="#303036"
    />
  </svg>
);
export const Upload = () => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill"
      d="M13 5.1V5C13 2.2 10.8 0 8 0C5.5 0 3.4 1.8 3.1 4.3C1.3 4.9 0 6.5 0 8.5C0 11 2 13 4.5 13C6.2 13 10.4 13 12 13C14.2 13 16 11.2 16 9C16 7.1 14.7 5.6 13 5.1ZM9 8V11H7V8H4L8 4L12 8H9Z"
      fill="#303036"
    />
  </svg>
);

export const PcBug = () => (
  <svg
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0638 9.17027C13.025 9.23558 12.97 9.28969 12.904 9.32727C12.838 9.36486 12.7634 9.38463 12.6875 9.38464C12.609 9.38462 12.5319 9.36346 12.4644 9.32339C11.8701 8.96535 11.1894 8.77615 10.4956 8.77615C9.80182 8.77615 9.12115 8.96535 8.52687 9.32339C8.47737 9.3594 8.42085 9.38461 8.36099 9.39741C8.30112 9.4102 8.23924 9.41029 8.17934 9.39767C8.11944 9.38504 8.06285 9.35999 8.01324 9.32413C7.96363 9.28826 7.9221 9.24239 7.89133 9.18947C7.86056 9.13654 7.84124 9.07775 7.83462 9.0169C7.828 8.95604 7.83422 8.89447 7.85289 8.83617C7.87155 8.77787 7.90225 8.72413 7.94298 8.67844C7.98372 8.63274 8.03359 8.5961 8.08937 8.57089C8.81624 8.13477 9.64796 7.9044 10.4956 7.9044C11.3433 7.9044 12.175 8.13477 12.9019 8.57089C12.952 8.59947 12.996 8.63769 13.0313 8.68334C13.0666 8.729 13.0925 8.78118 13.1076 8.83689C13.1226 8.8926 13.1265 8.95074 13.119 9.00796C13.1114 9.06517 13.0927 9.12033 13.0638 9.17027ZM8.18563 4.26152L8.05437 4.13464L8.18563 4.00777C8.22642 3.96698 8.25877 3.91855 8.28085 3.86525C8.30293 3.81196 8.31429 3.75483 8.31429 3.69714C8.31429 3.63946 8.30293 3.58233 8.28085 3.52903C8.25877 3.47574 8.22642 3.42731 8.18563 3.38652C8.14483 3.34573 8.09641 3.31337 8.04311 3.29129C7.98981 3.26922 7.93269 3.25785 7.875 3.25785C7.81731 3.25785 7.76019 3.26922 7.70689 3.29129C7.65359 3.31337 7.60517 3.34573 7.56438 3.38652L7.4375 3.51777L7.31062 3.38652C7.22824 3.30414 7.11651 3.25785 7 3.25785C6.88349 3.25785 6.77176 3.30414 6.68937 3.38652C6.60699 3.4689 6.56071 3.58064 6.56071 3.69714C6.56071 3.81365 6.60699 3.92539 6.68937 4.00777L6.82063 4.13464L6.68937 4.26152C6.64837 4.30219 6.61582 4.35058 6.59361 4.40389C6.5714 4.4572 6.55996 4.51439 6.55996 4.57214C6.55996 4.6299 6.5714 4.68708 6.59361 4.7404C6.61582 4.79371 6.64837 4.8421 6.68937 4.88277C6.73005 4.92377 6.77843 4.95632 6.83175 4.97853C6.88506 5.00075 6.94225 5.01218 7 5.01218C7.05775 5.01218 7.11494 5.00075 7.16825 4.97853C7.22157 4.95632 7.26995 4.92377 7.31062 4.88277L7.4375 4.75152L7.56438 4.88277C7.60505 4.92377 7.65343 4.95632 7.70675 4.97853C7.76006 5.00075 7.81725 5.01218 7.875 5.01218C7.93275 5.01218 7.98994 5.00075 8.04325 4.97853C8.09657 4.95632 8.14495 4.92377 8.18563 4.88277C8.22663 4.8421 8.25918 4.79371 8.28139 4.7404C8.3036 4.68708 8.31504 4.6299 8.31504 4.57214C8.31504 4.51439 8.3036 4.4572 8.28139 4.40389C8.25918 4.35058 8.22663 4.30219 8.18563 4.26152ZM14.3106 3.38652C14.27 3.34551 14.2216 3.31296 14.1683 3.29075C14.1149 3.26854 14.0578 3.25711 14 3.25711C13.9422 3.25711 13.8851 3.26854 13.8317 3.29075C13.7784 3.31296 13.73 3.34551 13.6894 3.38652L13.5625 3.51777L13.4356 3.38652C13.3532 3.30414 13.2415 3.25785 13.125 3.25785C13.0085 3.25785 12.8968 3.30414 12.8144 3.38652C12.732 3.4689 12.6857 3.58064 12.6857 3.69714C12.6857 3.81365 12.732 3.92539 12.8144 4.00777L12.9456 4.13464L12.8144 4.26152C12.7734 4.30219 12.7408 4.35058 12.7186 4.40389C12.6964 4.4572 12.685 4.51439 12.685 4.57214C12.685 4.6299 12.6964 4.68708 12.7186 4.7404C12.7408 4.79371 12.7734 4.8421 12.8144 4.88277C12.855 4.92377 12.9034 4.95632 12.9567 4.97853C13.0101 5.00075 13.0672 5.01218 13.125 5.01218C13.1828 5.01218 13.2399 5.00075 13.2933 4.97853C13.3466 4.95632 13.395 4.92377 13.4356 4.88277L13.5625 4.75152L13.6894 4.88277C13.73 4.92377 13.7784 4.95632 13.8317 4.97853C13.8851 5.00075 13.9422 5.01218 14 5.01218C14.0578 5.01218 14.1149 5.00075 14.1683 4.97853C14.2216 4.95632 14.27 4.92377 14.3106 4.88277C14.3516 4.8421 14.3842 4.79371 14.4064 4.7404C14.4286 4.68708 14.44 4.6299 14.44 4.57214C14.44 4.51439 14.4286 4.4572 14.4064 4.40389C14.3842 4.35058 14.3516 4.30219 14.3106 4.26152L14.1794 4.13464L14.3106 4.00777C14.3516 3.9671 14.3842 3.91871 14.4064 3.8654C14.4286 3.81208 14.44 3.7549 14.44 3.69714C14.44 3.63939 14.4286 3.5822 14.4064 3.52889C14.3842 3.47558 14.3516 3.42719 14.3106 3.38652ZM21 11.5721V13.3221C21 13.6702 20.8617 14.0041 20.6156 14.2502C20.3694 14.4964 20.0356 14.6346 19.6875 14.6346H1.3125C0.964403 14.6346 0.630564 14.4964 0.384422 14.2502C0.138281 14.0041 0 13.6702 0 13.3221L0 11.5721C0 11.4561 0.0460936 11.3448 0.128141 11.2628C0.210188 11.1807 0.321468 11.1346 0.4375 11.1346H1.3125V1.07214C1.3125 0.956111 1.35859 0.844832 1.44064 0.762784C1.52269 0.680737 1.63397 0.634644 1.75 0.634644H19.25C19.366 0.634644 19.4773 0.680737 19.5594 0.762784C19.6414 0.844832 19.6875 0.956111 19.6875 1.07214V11.1346H20.5625C20.6785 11.1346 20.7898 11.1807 20.8719 11.2628C20.9539 11.3448 21 11.4561 21 11.5721ZM2.1875 11.1346H18.8125V1.50964H2.1875V11.1346ZM20.125 12.0096H0.875V13.3221C0.875 13.4382 0.921094 13.5495 1.00314 13.6315C1.08519 13.7136 1.19647 13.7596 1.3125 13.7596H19.6875C19.8035 13.7596 19.9148 13.7136 19.9969 13.6315C20.0789 13.5495 20.125 13.4382 20.125 13.3221V12.0096Z"
      fill="white"
    />
  </svg>
);
